//
//  src/utils/Gclid.js
//
const GCLID_MAX_AGE_SECONDS = 30 * 24 * 60 * 60;


//
//  function[s]
//
function writeGclidSession(value) {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(GCLID_SESSION_KEY, value);
}

function readGclidSession() {
    if (typeof sessionStorage === 'undefined') return null;
    try {
        return sessionStorage.getItem(GCLID_SESSION_KEY);
    } catch (e) {
        return null;
    }
}

function writeGclidCookie(value) {
    if (typeof document === 'undefined') return;
    const secure =
        typeof window !== 'undefined' && window.location.protocol === 'https:'
            ? '; Secure'
            : '';
    document.cookie = `${GCLID_SESSION_KEY}=${encodeURIComponent(value)}; Path=/; Max-Age=${GCLID_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}

function readGclidCookie() {
    if (typeof document === 'undefined') return null;
    const prefix = `${GCLID_SESSION_KEY}=`;
    const parts = document.cookie.split(';');
    for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (part.startsWith(prefix)) {
            try {
                return decodeURIComponent(part.slice(prefix.length));
            } catch (e) {
                return null;
            }
        }
    }
    return null;
}


//
//  export[s]
//
export const GCLID_SESSION_KEY = 'jefftattooer_gclid';

export function persistGclidFromSearch(search) {
    const params = new URLSearchParams(search || '');
    const g = params.get('gclid');
    if (!g) return;

    try {
        writeGclidSession(g);
    } catch (e) {
        // private mode / blocked storage
    }
    try {
        writeGclidCookie(g);
    } catch (e) {
        // blocked cookies
    }
}

export function readStoredGclid() {
    try {
        const fromSession = readGclidSession();
        if (fromSession) return fromSession;
        return readGclidCookie();
    } catch (e) {
        return null;
    }
}
